export default __webpack_public_path__ + "static/soc-2-logo-72cba272a77fed46056adcf0d55db556.png";